import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { StyleService } from '../../services/style/style.service';

/**
 * LogoComponent represents the theme logo with a url provided by the Style Service
 */
@Component({
  selector: 'app-logo',
  standalone: true,
  imports: [],
  templateUrl: './logo.component.html',
  styleUrl: './logo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogoComponent {
  // Use the style service to obtain the logo url
  private styleService = inject(StyleService);
  public logoSrc = computed(() => this.styleService.styles().brand.logoUrl);
}
